import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../AuthContext';
import { Form, Button, Container, Row, Col, Spinner, Alert, Card } from 'react-bootstrap';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [waitingForOtp, setWaitingForOtp] = useState(false);
    const { loginUser, loading, error, otpRequired, authTokens } = useContext(AuthContext);

    useEffect(() => {
        return () => {
            setUsername('');
            setPassword('');
            setWaitingForOtp(false);
        };
    }, []);

    useEffect(() => {
        if (authTokens && !otpRequired) {
            window.location.href = '/';
        }
    }, [authTokens, otpRequired]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        if (!username.trim() || !password.trim()) {
            return;
        }

        try {
            setWaitingForOtp(false);
            const success = await loginUser(username, password);
            if (success && otpRequired) {
                setWaitingForOtp(true);
            }
        } catch (error) {
            console.error('Ошибка входа:', error);
        }
    };

    const handleInputChange = (setter) => (e) => {
        setter(e.target.value);
    };

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{
            background: '#303238'
        }}>
            <Container>
                <Row className="justify-content-center">
                    <Col xs={11} sm={8} md={4} lg={3} xl={2}> {/* Уменьшены размеры колонок */}
                        <Card className="shadow-lg border-0" style={{
                            background: 'rgba(255, 255, 255, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '16px',
                            border: '1px solid rgba(255, 255, 255, 0.2)'
                        }}>
                            <div className="text-center py-4 px-3">
                                <div style={{
                                    width: '60px',
                                    height: '60px',
                                    background: 'rgba(255, 255, 255, 0.15)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto 1rem'
                                }}>
                                    <i className="fas fa-user-shield" style={{ fontSize: '1.5rem', color: 'white' }}></i>
                                </div>
                                <h4 className="text-white mb-1 fw-bold">Вход в систему</h4>
                                <p className="text-white-50 mb-0 small">Управление складом</p>
                            </div>
                            
                            <Card.Body className="px-4 pb-4 pt-0">
                                {error && (
                                    <Alert variant="danger" className="mb-3 small" style={{
                                        borderRadius: '8px',
                                        border: 'none',
                                        background: 'rgba(220, 53, 69, 0.2)',
                                        color: '#f8d7da',
                                        border: '1px solid rgba(220, 53, 69, 0.3)'
                                    }}>
                                        <i className="fas fa-exclamation-triangle me-2"></i>
                                        {error}
                                    </Alert>
                                )}
                                
                                {waitingForOtp ? (
                                    <div className="text-center py-3">
                                        <div className="mb-3">
                                            <Spinner animation="border" variant="light" size="sm" />
                                        </div>
                                        <h6 className="text-white mb-2">Отправляем код</h6>
                                        <p className="text-white-50 small mb-0">Подождите...</p>
                                    </div>
                                ) : (
                                    <Form onSubmit={handleSubmit} autoComplete="off">
                                        <Form.Group controlId="username" className="mb-3">
                                            <Form.Label className="text-white fw-semibold small">
                                                <i className="fas fa-user me-2"></i>
                                                Пользователь
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={username}
                                                onChange={handleInputChange(setUsername)}
                                                required
                                                autoComplete="username"
                                                disabled={loading}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid rgba(255, 255, 255, 0.3)',
                                                    background: 'rgba(255, 255, 255, 0.1)',
                                                    color: 'white',
                                                    padding: '0.75rem'
                                                }}
                                            />
                                        </Form.Group>
                                        
                                        <Form.Group controlId="password" className="mb-4">
                                            <Form.Label className="text-white fw-semibold small">
                                                <i className="fas fa-lock me-2"></i>
                                                Пароль
                                            </Form.Label>
                                            <Form.Control
                                                type="password"
                                                value={password}
                                                onChange={handleInputChange(setPassword)}
                                                required
                                                autoComplete="current-password"
                                                disabled={loading}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid rgba(255, 255, 255, 0.3)',
                                                    background: 'rgba(255, 255, 255, 0.1)',
                                                    color: 'white',
                                                    padding: '0.75rem'
                                                }}
                                            />
                                        </Form.Group>
                                        
                                        <Button 
                                            type="submit" 
                                            className="w-100" 
                                            disabled={loading || !username.trim() || !password.trim()}
                                            style={{
                                                background: 'linear-gradient(135deg, #495057 0%, #343a40 100%)',
                                                border: 'none',
                                                borderRadius: '8px',
                                                padding: '0.75rem',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                transition: 'all 0.3s ease'
                                            }}
                                        >
                                            {loading ? (
                                                <>
                                                    <Spinner 
                                                        as="span" 
                                                        animation="border" 
                                                        size="sm" 
                                                        className="me-2"
                                                    />
                                                    Вход...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-sign-in-alt me-2"></i>
                                                    Войти
                                                </>
                                            )}
                                        </Button>
                                    </Form>
                                )}
                            </Card.Body>
                        </Card>
                        
                        <div className="text-center mt-3">
                            <small className="text-white-50">
                                <i className="fas fa-shield-alt me-1"></i>
                                Защищенная система
                            </small>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LoginPage;